import { ReactNode } from "react";
import { LockKeyhole } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useModulosSaas } from "@/hooks/useModulosSaas";
import { Link } from "react-router-dom";

type ModuleRouteProps = {
  modulo: string;
  children: ReactNode;
};

export function ModuleRoute({ modulo, children }: ModuleRouteProps) {
  const { loading, hasModulo, getModulo } = useModulosSaas();
  const moduleInfo = getModulo(modulo);

  if (loading) return <>{children}</>;
  if (hasModulo(modulo)) return <>{children}</>;

  return (
    <DashboardLayout>
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <Card className="w-full max-w-lg">
          <CardContent className="space-y-4 p-6 text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-md bg-muted">
              <LockKeyhole className="h-6 w-6 text-muted-foreground" />
            </div>
            <div>
              <h1 className="text-xl font-semibold">{moduleInfo?.nome || "Módulo não liberado"}</h1>
              <p className="mt-2 text-sm text-muted-foreground">
                Este recurso ainda não está ativo para esta conta. O administrador do cliente pode solicitar a liberação na central de módulos.
              </p>
            </div>
            <Button asChild>
              <Link to="/cliente/modulos">Abrir módulos</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
